import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class offboarding_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `
           
          

            
            <div class="list-header w-justify" >
                <div class="w-left">
                    <div class="form-check-inline">                  
                        <input type="checkbox" data-bind="checked: isShowActiveUsers, click: showActiveUsers" id="showActiveUser">
                        <label for="showActiveUser" class="form-label icon i-check">Show Active Users</label>   
                    </div>                    
                </div>
                <div class="w-center">
                
                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div class="w-list-results offboarding" id="list-results">
                <table class="list-results ">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='fullName_DESC', 'list-sort-asc': orderByAndDirection()=='fullName_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loginName') }, css: { 'list-sort-desc': orderByAndDirection()=='loginName_DESC', 'list-sort-asc': orderByAndDirection()=='loginName_ASC' }">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'email') }, css: { 'list-sort-desc': orderByAndDirection()=='email_DESC', 'list-sort-asc': orderByAndDirection()=='email_ASC' }">Email</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'effectiveDate') }, css: { 'list-sort-desc': orderByAndDirection()=='effectiveDate_DESC', 'list-sort-asc': orderByAndDirection()=='effectiveDate_ASC' }">Effective Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency') }, css: { 'list-sort-desc': orderByAndDirection()=='currency_DESC', 'list-sort-asc': orderByAndDirection()=='currency_ASC' }">Currency</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: users">
    
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }" class="flex">
                                <!--<button class="btn no-bg icon i-star-full" type="button"></button>-->
                                <div class="w-user-img"><img class="user-img" data-bind="attr:{src: pictureUrl}" alt=""></div>
                                <span data-bind="text: fullName"></span>
                                <a class="btn icon border only-icon i-link" data-bind="event: { click: $parent.onClickShowUser }"></a>
                            </td>

                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: loginName"></span></td>
                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: email"></span></td>
                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: effectiveDate"></span></td>
                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: currency"></span></td>
                        </tr>
                    </tbody>
                </table>
                
           <div id="user-transactions-dialog"  class="w-lightbox light-theme">
                <div class="lightbox-content" >
                  <div class="w-form  lightbox-form">
                    <div class="form-header">
                      <h3 class="form-title icon i-recruit" data-bind="text: selectedUser().fullName"></h3>
                      <button class="close-button icon i-close-2" data-bind="event: {click: onClickHideDialog }" type="button"></button>
                    </div>
                    <div class="form-body">
                      <table class="list-action transactions" >
                          <thead>
                              <tr>   
                                  <th><span>Brand</span> </th>
                                  <th><span>Commission</span> </th>
                                  <th><span>Performance</span> </th>
                                  <th><span>Consulting Base</span></th>
                                  <th><span>Bonus</span> </th>
                                  <th><span>Other</span> </th>
                                  <th><span>Total</span> </th>       
                              </tr>
                          </thead>
                          <tbody data-bind="foreach: userTransactions">
                          <tr >
                              <td> <span data-bind="text: brand"></span></td>
                              <td class="align-right"> <span data-bind="text: commission"></span></td>
                              <td class="align-right"> <span data-bind="text: performance"></span></td>
                              <td class="align-right"> <span data-bind="text: consulting_base"></span></td>
                              <td class="align-right"> <span data-bind="text: bonus"></span></td>
                              <td class="align-right"> <span data-bind="text: other"></span></td>
                              <td class="align-right"> <span data-bind="text: total"></span></td>
                              </tr>
                          </tbody>
                          <tbody data-bind="visible: userTransactions().length == 0">
                            <tr>
                                <td colspan="7">No transaction available</td>
                            </tr>
                          </tbody>
                          <tfoot data-bind="visible: userTransactions().length > 0">
                            <tr>
                                <td colspan="6">Total</td>
                                <td class="align-right" data-bind="text: total"></td>
                            </tr>
                          </tfoot>
                      </table>
                   </div>
                   <div class="form-footer">
                    <button title="Show Pro-Rated" class="btn" type="button" data-bind="event: {click: onClickShowProrated}, visible: prorateButtonVisible()">Show Pro-Rated</button>        
                    <button title="Hide Pro-Rated" class="btn" type="button" data-bind="event: {click: onClickHideProrated}, visible: !prorateButtonVisible()">Hide Pro-Rated</button>                
                    <button title="Close this pop up" class="btn" type="button" data-bind="event: {click: onClickHideDialog }">Close</button>
                   </div>
                 </div>   
            </div>
            </div>    
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string {
        return "offboarding-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("effectiveDate")
            , orderByDirection: ko.observable("DESC")
            , users: ko.observableArray([])
            , orderByAndDirection: ko.observable("effectiveDate_DESC")
            , isShowActiveUsers: ko.observable(true)
            , selectedUser: ko.observable(true)
            , userTransactions: ko.observableArray([])
            , transactionIdUser: ko.observable()
            , total: ko.observable(0)
            , prorateButtonVisible: ko.observable(true)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickView: function (data, event) {
                huit_neuf_this.onClickView(data);
            }
            , onClickShowUser: function (data, event){
                huit_neuf_this.onClickShowUser(data.id);
            }
            , onClickShowProrated: function (data, event) {
                huit_neuf_this.onClickShowProrated();
            }
            , onClickHideProrated: function (data, event) {
                huit_neuf_this.onClickHideProrated();
            }
            , onClickHideDialog: function (data, event) {
                huit_neuf_this.onClickHideDialog();
            }
            , showActiveUsers: function (data) {
                huit_neuf_this.showActiveUsers()
                return true;
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
                isActive : this.getTemplateViewModel().isShowActiveUsers
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }

    public onClickView(data) {

        this.getTemplateViewModel().transactionIdUser(data.id);
        this.getTemplateViewModel().selectedUser(data);
        this.caller.getTransactionsForUser(data.id);
    }

    public onClickShowUser(id){

        this.caller.viewUser(id);
    }

    public setUsers(users: Array<{ pictureUrl: string, fullName: string, loginName: string, email: string, effectiveDate: string, currency: string }>): void {

        this.getTemplateViewModel().users(users);
    }
    public setTotal(total): void {

        this.getTemplateViewModel().total(total);
    }

    public setTransactions(transactions){

        this.getTemplateViewModel().userTransactions(transactions);
        document.getElementById('user-transactions-dialog').classList.add('is-visible');
    }

    public showActiveUsers() {
        this.caller.onShowActiveUsers();
        return true;
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickHideDialog() {

        document.getElementById('user-transactions-dialog').classList.remove('is-visible');
        this.getTemplateViewModel().prorateButtonVisible(true);
    }

    public onClickShowProrated() {

        this.caller.getProratedTransactionsForUser(this.getTemplateViewModel().transactionIdUser());
        this.getTemplateViewModel().prorateButtonVisible(false);
    }

    public onClickHideProrated(){

        this.caller.getTransactionsForUser(this.getTemplateViewModel().transactionIdUser());
        this.getTemplateViewModel().prorateButtonVisible(true);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/offboarding_template.ts